import { useLayoutEffect } from 'react';

export function useNoReferrer() {
  // A layout effect installs the policy before any child passive effect can fetch.
  useLayoutEffect(() => {
    const existing = document.head.querySelector('meta[name="referrer"]');
    const previous = existing?.getAttribute('content');
    const meta = existing || document.createElement('meta');
    meta.setAttribute('name', 'referrer');
    meta.setAttribute('content', 'no-referrer');
    if (!existing) document.head.appendChild(meta);
    return () => {
      if (!existing) meta.remove();
      else if (previous == null) existing.removeAttribute('content');
      else existing.setAttribute('content', previous);
    };
  }, []);
}
